// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const WarningSolid = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.38 4.545a1.595 1.595 0 0 0-2.76 0L2.34 18.864c-.612 1.06.154 2.386 1.38 2.386h16.56c1.226 0 1.992-1.326 1.38-2.386L13.38 4.545Zm-.64 9.803a.74.74 0 1 1-1.48 0V8.435a.74.74 0 1 1 1.48 0v5.913Zm.248 3.206a.987.987 0 0 1-1.976 0 .987.987 0 0 1 1.976 0Z"
			fill="#D12C2C"
		/>
	</svg>
);
export default WarningSolid;
